import { ReactElement, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useControlStore } from '@editorStores'

interface Props {
  children: ReactNode
}

/**
 * Renders the guided IFC toolbar into the scene toolbar slot registered by the IFC Import toolbar
 * (only present while guided mode is active).
 */
const GuidedToolbarPortal = ({ children }: Props): ReactElement => {
  const element = useControlStore(state => state.ifcGuidedToolbarElement)

  return <>{element && createPortal(<>{children}</>, element)}</>
}

export default GuidedToolbarPortal
